import React from 'react';
import { Button, Modal, } from 'react-bootstrap';
import PropTypes from 'prop-types';
import EventEmitter from 'events';

class BaseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleShow() {
    const { onShow, } = this.props;

    this.setState({
      show: true,
    });
    onShow();
  }

  handleClose() {
    const { onHide, } = this.props;
    this.setState({
      show: false,
    });
    onHide();
  }

  render() {
    const {
      buttonLbl, title, modalSize, children, events,
    } = this.props;
    const { show, } = this.state;

    if (events) events.on('close', this.handleClose.bind(this));

    return (
      <div>
        <Button variant="primary" onClick={() => this.handleShow()}>
          {buttonLbl}
        </Button>
        <Modal show={show} onHide={() => this.handleClose()} size={modalSize}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      </div>
    );
  }
}

BaseModal.defaultProps = {
  title: '',
  modalSize: 'xl',
  buttonLbl: 'Submit',
  children: {},
  onShow: () => {},
  onHide: () => {},
  events: new EventEmitter(),
};

BaseModal.propTypes = {
  title: PropTypes.string,
  modalSize: PropTypes.string,
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array, ]),
  buttonLbl: PropTypes.string,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  events: PropTypes.any,
};

export default BaseModal;
